module.exports = __webpack_public_path__ + "static/avatar-05848e1772c2baaff564e9a0c9037ef5.png";